import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as colorHelpersStyles } from '../../../assets/color-helpers.scss';

export const templateResponseGrid = document.createElement('template');

templateResponseGrid.innerHTML = `
  <style>${colorHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class="wrapper">
    <gz-push-body-layout>
      <div slot="push-body-sidenav-title">
        <gz-title id="smart-views-title" fontWeight='600' fontSize='11'></gz-title>
      </div>
      <div slot="push-body-sidenav">
      </div>
      <div slot="push-body-content">
        <gz-grid-view  hasSelectableRows showGlobalActions>
          <div class="controls-header" slot="grid-header-actions-slot">
            <!-- button text is added in view, because it needs to be translated -->
            <gz-tooltip id="executeTooltip">
                <gz-button id="executeButton" disabled class="primary"></gz-button>
            </gz-tooltip>
            <gz-select id="manageButtonSelections" disabled class="manageButtonSelections" options="[{&quot;title&quot;:&quot;placeholderTitle&quot;,&quot;value&quot;:&quot;1&quot;,&quot;customClass&quot;:&quot;danger&quot;}]" >
              <gz-button id="manageButton" class="action-button" type="quiet" color="secondary">
                <span id="manageButtonText" data-actions class="action-button-text"></span>
                <span class="action-icon ds-icon-dropdown_arrow"></span>
              </gz-button>
          </gz-select>
          </div>
        </gz-grid-view>
      </div>
    </gz-push-body-layout>
  </div>
`;
